var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "search col-11" },
        [
          _c("b-form-input", {
            attrs: { size: "sm", placeholder: "Buscar", autocomplete: "off" },
            model: {
              value: _vm.query,
              callback: function($$v) {
                _vm.query = $$v
              },
              expression: "query"
            }
          })
        ],
        1
      ),
      _vm._l(_vm.filteredItems, function(item, index) {
        return _c(
          "div",
          { key: "item.bitacoraId-" + index, staticClass: "row" },
          [
            _c("div", { staticClass: "binnacle col-11" }, [
              _c("div", { staticClass: "wrapper" }, [
                _c("div", {
                  staticClass: "avatar round",
                  style: {
                    "background-image": "url(" + item.usuarioAvatar + ")",
                    "background-size": "50px 50px"
                  }
                }),
                _c("div", { staticClass: "user-info" }, [
                  _c("div", { staticClass: "name" }, [
                    _vm._v(_vm._s(item.usuarioNombre))
                  ]),
                  _c("div", { staticClass: "mail" }, [
                    _vm._v(_vm._s(item.usuarioCorreo))
                  ])
                ])
              ]),
              _c("div", { staticClass: "message" }, [
                _vm._v(_vm._s(item.mensaje))
              ]),
              _c("div", { staticClass: "date" }, [
                _vm._v(
                  " " + _vm._s(_vm.$moment(item.fecha).format("LLLL")) + " "
                )
              ])
            ])
          ]
        )
      }),
      _vm.loading
        ? _c("div", [
            _c("div", { staticClass: "row mt-3" }, [
              _c(
                "div",
                { staticClass: "col-1" },
                [
                  _c("b-skeleton", {
                    attrs: { animation: "fade", type: "avatar" }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-9" },
                [
                  _c("b-skeleton", {
                    attrs: { animation: "fade", type: "input" }
                  })
                ],
                1
              )
            ])
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }